import { render, staticRenderFns } from "./sk-card.vue?vue&type=template&id=00b02194"
import script from "./sk-card.vue?vue&type=script&lang=js"
export * from "./sk-card.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports